<template>
   <v-row justify="center">
    <v-col cols="12" sm="10" md="8" lg="6">
      <v-card ref="form">
        <v-card-title> Add New Medication </v-card-title>
        <v-card-text>
          <!-- Medication Type Tabs -->
          <v-tabs v-model="activeTab" background-color="primary" dark>
            <v-tab>Normal Medication</v-tab>
            <v-tab>Control Drug</v-tab>
          </v-tabs>

          <!-- Tab Content -->
          <v-tabs-items v-model="activeTab">
            <!-- Normal Medication Tab -->
            <v-tab-item>
              <v-container fluid>
                <v-text-field
                  v-model="normalMedication.name"
                  label="Medication Name"
                  required
                ></v-text-field>

                <v-text-field
                  v-model="normalMedication.directive"
                  label="Directives"
                  required
                ></v-text-field>
                 
                <v-text-field
                  v-model="normalMedication.description"
                  label="Description"
                  required
                ></v-text-field>
                 
                <v-text-field
                  v-model="normalMedication.type"
                  label="Type"
                  required
                ></v-text-field>
                 
                <v-text-field
                  v-model="normalMedication.pharmacy"
                  label="Pharmacy"
                  required
                ></v-text-field>
                 
                <v-text-field
                  v-model="normalMedication.quantity.order"
                  label="Quantity Order"
                  type="number"
                  required
                ></v-text-field>
                 
                <v-text-field
                  v-model="normalMedication.quantity.receive"
                  label="Quantity Receive"
                  type="number"
                  required
                ></v-text-field>
                 
                <v-row>
                  <v-col cols="12" sm="6" md="4" class="mr-12">
                    <v-menu
                      v-model="normalMedication.menu1"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="normalMedication.startDate"
                          label="Start Date"
                          prepend-icon="event"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="normalMedication.startDate" no-title scrollable
                        @input="normalMedication.menu1 = false"
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" class="ml-12 pl-2">
                    <v-menu
                      v-model="normalMedication.menu2"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="normalMedication.endDate"
                          label="End Date"  
                          prepend-icon="event"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="normalMedication.endDate" no-title scrollable
                        @input="normalMedication.menu2 = false"
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>

                <!-- Medication Schedule Section -->
                <v-divider class="my-4"></v-divider>
                <h3 class="mb-3">Medication Schedule</h3>
                
                <!-- Schedule Time -->
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-menu
                      v-model="normalMedication.scheduleTimeMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="normalMedication.scheduleTime"
                          label="Administration Time"
                          prepend-icon="access_time"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-time-picker v-model="normalMedication.scheduleTime" no-title scrollable
                        @input="normalMedication.scheduleTimeMenu = false"
                        format="24hr"
                      >
                      </v-time-picker>
                    </v-menu>
                  </v-col>
                </v-row>

                <!-- Days of Week Checkboxes -->
                <v-row>
                  <v-col cols="12">
                    <v-subheader class="px-0">Select days when medication is needed:</v-subheader>
                    <v-row>
                      <v-col cols="6" sm="4" md="3" v-for="day in daysOfWeek" :key="day.value">
                        <v-checkbox
                          v-model="normalMedication.schedule[day.value]"
                          :label="day.label"
                          color="primary"
                          hide-details
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

              </v-container>
            </v-tab-item>

            <!-- Control Drug Tab -->
            <v-tab-item>
              <v-container fluid>
                <v-text-field
                  v-model="controlDrug.name"
                  label="Control Drug Name"
                  required
                ></v-text-field>

                <v-text-field
                  v-model="controlDrug.directive"
                  label="Directives"
                  required
                ></v-text-field>
                 
                <v-text-field
                  v-model="controlDrug.pharmacy"
                  label="Pharmacy"
                  required
                ></v-text-field>
                 
                <v-text-field
                  v-model="controlDrug.quantityOrder"
                  label="Quantity Order"
                  type="number"
                  required
                ></v-text-field>
                 
                <v-text-field
                  v-model="controlDrug.quantityReceived"
                  label="Quantity Receive"
                  type="number"
                  required
                ></v-text-field>
                 
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-menu
                      v-model="controlDrug.receiveDateMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="controlDrug.receiveDate"
                          label="Receive Date"
                          prepend-icon="event"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="controlDrug.receiveDate" no-title scrollable
                        @input="controlDrug.receiveDateMenu = false"
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-menu
                      v-model="controlDrug.receiveTimeMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="controlDrug.receiveTime"
                          label="Receive Time"
                          prepend-icon="access_time"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-time-picker v-model="controlDrug.receiveTime" no-title scrollable
                        @input="controlDrug.receiveTimeMenu = false"
                        format="24hr"
                      >
                      </v-time-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                 
                <v-row>
                  <v-col cols="12" sm="6" md="4" class="mr-12">
                    <v-menu
                      v-model="controlDrug.menu1"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="controlDrug.startDate"
                          label="Start Date"  
                          prepend-icon="event"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="controlDrug.startDate" no-title scrollable
                        @input="controlDrug.menu1 = false"
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" class="ml-12 pl-2">
                    <v-menu
                      v-model="controlDrug.menu2"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="controlDrug.endDate"
                          label="End Date"  
                          prepend-icon="event"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="controlDrug.endDate" no-title scrollable
                        @input="controlDrug.menu2 = false"
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                 
                <v-text-field
                  v-model="controlDrug.witness"
                  label="Witness"
                  required
                ></v-text-field>

                <!-- Medication Schedule Section -->
                <v-divider class="my-4"></v-divider>
                <h3 class="mb-3">Medication Schedule</h3>
                
                <!-- Schedule Time -->
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-menu
                      v-model="controlDrug.scheduleTimeMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="controlDrug.scheduleTime"
                          label="Administration Time"
                          prepend-icon="access_time"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-time-picker v-model="controlDrug.scheduleTime" no-title scrollable
                        @input="controlDrug.scheduleTimeMenu = false"
                        format="24hr"
                      >
                      </v-time-picker>
                    </v-menu>
                  </v-col>
                </v-row>

                <!-- Days of Week Checkboxes -->
                <v-row>
                  <v-col cols="12">
                    <v-subheader class="px-0">Select days when medication is needed:</v-subheader>
                    <v-row>
                      <v-col cols="6" sm="4" md="3" v-for="day in daysOfWeek" :key="day.value">
                        <v-checkbox
                          v-model="controlDrug.schedule[day.value]"
                          :label="day.label"
                          color="primary"
                          hide-details
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

              </v-container>
            </v-tab-item>
          </v-tabs-items>

          <!-- Submit Button -->
          <v-btn
            color="warning"
            @click="register"
            :loading="loading"
            class="mt-4"
          >
            Submit
          </v-btn>
        </v-card-text>
      </v-card>
    </v-col>
   </v-row>
</template>

<script>
import {mapGetters, mapActions } from 'vuex'
import moment from 'moment';

export default {
    name:'registerMedication',
    data () {
      return {
        activeTab: 0,
        loading: false,
        daysOfWeek: [
          { value: 'monday', label: 'Monday' },
          { value: 'tuesday', label: 'Tuesday' },
          { value: 'wednesday', label: 'Wednesday' },
          { value: 'thursday', label: 'Thursday' },
          { value: 'friday', label: 'Friday' },
          { value: 'saturday', label: 'Saturday' },
          { value: 'sunday', label: 'Sunday' }
        ],
        normalMedication: {
          name: '',
          directive: '',
          description: '',
          quantity: {
            order: 0,
            receive: 0,
          },
          type: '',
          pharmacy: '',
          startDate: null,
          endDate: null,
          menu1: false,
          menu2: false,
          scheduleTime: '',
          scheduleTimeMenu: false,
          schedule: {
            monday: false,
            tuesday: false,
            wednesday: false,
            thursday: false,
            friday: false,
            saturday: false,
            sunday: false
          }
        },
        controlDrug: {
          name: '',
          directive: '',
          receiveDate: '',
          receiveTime: '',
          pharmacy: '',
          quantityOrder: 0,
          quantityReceived: 0,
          startDate: null,
          endDate: null,
          witness: '',
          menu1: false,
          menu2: false,
          receiveDateMenu: false,
          receiveTimeMenu: false,
          scheduleTime: '',
          scheduleTimeMenu: false,
          schedule: {
            monday: false,
            tuesday: false,
            wednesday: false,
            thursday: false,
            friday: false,
            saturday: false,
            sunday: false
          }
        },
        resident: '',
        user: '',
      }
    },
    computed: {
        ...mapGetters([
           'getLoggedUser'
        ]),
    },
     created() {
       this.getLoggedInUser();
       this.resident = this.$route.params.residentId;
    },
    methods: {
      ...mapActions([
          'register_medication',
          'register_control_drug',
          'getLoggedInUser',
      ]),
      register () {
        this.loading = true;
        this.user = this.getLoggedUser.user.id;
        this.resident = this.$route.params.residentId;

        if (this.activeTab === 0) {
          // Register Normal Medication
          this.registerNormalMedication();
        } else {
          // Register Control Drug
          this.registerControlDrug();
        }
      },
      registerNormalMedication() {
        const medicationData = {
          name: this.normalMedication.name,
          directive: this.normalMedication.directive,
          description: this.normalMedication.description,
          type: this.normalMedication.type,
          pharmacy: this.normalMedication.pharmacy,
          quantity: {
            order: this.normalMedication.quantity.order,
            receive: this.normalMedication.quantity.receive,
          },
          startDate: this.formatDate(this.normalMedication.startDate),
          endDate: this.formatDate(this.normalMedication.endDate),
          schedule: this.normalMedication.schedule,
          scheduleTime: this.normalMedication.scheduleTime,
          resident: this.resident,
          user: this.user,
        };

        this.register_medication(medicationData)
          .then(() => {
            this.loading = false;
            this.$router.push('/medications');
          })
          .catch(error => {
            this.loading = false;
            console.log(error);
          });
      },
      registerControlDrug() {
        const controlDrugData = {
          name: this.controlDrug.name,
          directive: this.controlDrug.directive,
          pharmacy: this.controlDrug.pharmacy,
          quantityOrder: this.controlDrug.quantityOrder,
          quantityReceived: this.controlDrug.quantityReceived,
          receiveDate: this.formatDate(this.controlDrug.receiveDate),
          receiveTime: this.controlDrug.receiveTime,
          startDate: this.formatDate(this.controlDrug.startDate),
          endDate: this.formatDate(this.controlDrug.endDate),
          witness: this.controlDrug.witness,
          schedule: this.controlDrug.schedule,
          scheduleTime: this.controlDrug.scheduleTime,
          resident: this.resident,
          user: this.user,
        };

        this.register_control_drug(controlDrugData)
          .then(() => {
            this.loading = false;
            this.$router.push('/controlDrugRegister');
          })
          .catch(error => {
            this.loading = false;
            console.log(error);
          });
      },
      formatDate(date) {
        if (!date) return null;
        return moment(date).format('DD-MM-YYYY HH:mm');
      },
    },
}
</script>

<style lang="stylus" scoped>

</style>